module.exports = __webpack_public_path__ + "img/gall-8.e29a5042.jpg";